import { useState } from 'react'

const useComment = () => {
const [displayEdit, setDisplayEdit] = useState(false);
const [displayNewReply, setDisplayNewReply] = useState(false);
  return {
      displayEdit,
      setDisplayEdit,
      displayNewReply,
      setDisplayNewReply
  }
}

export default useComment